/** La position d'un toucher sur la piste d'un `<SeekBar>`, de 0 à 1. Pur : ses tests le rejouent. */
export function seekRatio(x: number, width: number): number {
    if (!(width > 0) || !Number.isFinite(x)) return 0
    return Math.max(0, Math.min(1, x / width))
}
